import React, { useEffect, useState, useContext } from "react";
import { getPosBatch } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

const POBatchreport = () => {
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

    const [summary, setSummary] = useState(null);
    const [batchData, setBatchData] = useState([]);
    const ITEMS_PER_PAGE = 10;
    const [currentPage, setCurrentPage] = useState(1);


    const fetchBatchReport = async () => {
        try {
            const params = {
                shop_id: shopItem?.shop_id || "",
            };
            showLoader();
            const res = await getPosBatch(params);
            if (res?.data?.status === "success") {
                setSummary(res.data.summary);
                setBatchData(res.data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        fetchBatchReport();
    }, []);
    const totalPages = Math.ceil(batchData.length / ITEMS_PER_PAGE);

    const paginatedData = batchData.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );


    return (
        <div className="container-fluid p-4 bg-white min-vh-100">

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                    <h3 className="fw-bold mb-0">PO Batch Analytics</h3>
                    <small className="text-muted">
                        Profit & loss breakdown by batch
                    </small>
                </div>
                <span className="badge bg-dark px-3 py-2">
                    <i className="bi bi-graph-up me-1"></i> Live Report
                </span>
            </div>

            {summary && (
                <div className="row g-3 mb-1">
                    {[
                        {
                            title: "Manufacturing Cost",
                            value: summary.total_mfg_price,
                            icon: "bi-cash-stack",
                            bg: "white",
                            color: "text-dark",
                        },
                        {
                            title: "Total Profit",
                            value: summary.total_profit,
                            icon: "bi-arrow-up-circle",
                            bg: "success",
                            color: "text-white",
                        },
                        {
                            title: "Total Loss",
                            value: summary.total_loss,
                            icon: "bi-arrow-down-circle",
                            bg: "danger",
                            color: "text-white",
                        },
                        {
                            title: "Net Result",
                            value: summary.net_result,
                            icon: "bi-bar-chart",
                            bg: summary.net_result >= 0 ? "primary" : "warning",
                            color: "text-white",
                        },
                    ].map((item, i) => (
                        <div className="col-xl-3 col-md-6" key={i}>
                            <div className={`card shadow-sm border-0 bg-${item.bg}`}>
                                <div className={`card-body ${item.color}`}>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <small className="opacity-75">{item.title}</small>
                                            <h4 className="fw-bold mt-1">₹ {item.value}</h4>
                                        </div>
                                        <i className={`bi ${item.icon} fs-2 opacity-50`}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* BATCH LIST */}
            <div className="card border-0 shadow-sm">
                <div className="card-header bg-white fw-bold">
                    <i className="bi bi-table me-2"></i>Batch-wise Profit / Loss
                </div>

                <div className="table-responsive">
                    <table className="table table-hover align-middle justify-content-center mb-0 ">
                        <thead className="table-light">
                            <tr>
                                <th>No</th>
                                <th>Batch No</th>
                                <th className="text-center">Sold Qty</th>
                                <th className="text-center">Sales (₹)</th>
                                <th className="text-center">Cost Mfg (₹)</th>
                                <th className="text-center">Profit (₹)</th>
                                <th className="text-center">Loss (₹)</th>
                                <th className="text-center">Net Result (₹)</th>
                            </tr>
                        </thead>

                        <tbody>
                        {batchData.length > 0 ? (
                            paginatedData.map((item, index) => (
                            <tr key={index}>
                                <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>

                                <td className="fw-semibold">
                                    {item.batch_no}
                                </td>

                                <td className="text-center">
                                    {item.sold_qty}
                                </td>

                                <td className="text-center">
                                    ₹ {item.sales_amount}
                                </td>

                                <td className="text-center">
                                    ₹ {item.cost_amount}
                                </td>

                                <td className="text-center">
                                    {item.total_profit > 0 ? (
                                        <span className="badge bg-success">
                                            +₹ {item.total_profit}
                                        </span>
                                    ) : (
                                        "-"
                                    )}
                                </td>

                                <td className="text-center">
                                    {item.total_loss > 0 ? (
                                        <span className="badge bg-danger">
                                            -₹ {item.total_loss}
                                        </span>
                                    ) : (
                                        "-"
                                    )}
                                </td>

                                <td className="text-center fw-bold">
                                    <span
                                        className={
                                            item.net_result >= 0
                                                ? "text-success"
                                                : "text-danger"
                                        }
                                    >
                                        ₹ {item.net_result}
                                    </span>
                                </td>
                            </tr>
                            ))
                            ) : (
                            <tr>
                                <td colSpan="8" className="text-center py-4 text-muted">
                                    <i className="bi bi-inbox me-2"></i>
                                    No Batch Data Available
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center p-3 border-top">

                            <small className="text-muted">
                                Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1} –
                                {Math.min(currentPage * ITEMS_PER_PAGE, batchData.length)} of{" "}
                                {batchData.length}
                            </small>

                            <nav>
                                <ul className="pagination mb-0">

                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(prev => prev - 1)}
                                        >
                                            Prev
                                        </button>
                                    </li>

                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                        .slice(
                                            Math.max(0, currentPage - 3),
                                            Math.min(totalPages, currentPage + 2)
                                        )
                                        .map(page => (
                                            <li
                                                key={page}
                                                className={`page-item ${currentPage === page ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(prev => prev + 1)}
                                        >
                                            Next
                                        </button>
                                    </li>

                                </ul>
                            </nav>
                        </div>
                    )}

                </div>
            </div></div>

    );
};

export default POBatchreport;
